import axios from 'axios';
import { callApi } from '@app/views/services/api';
axios.defaults.withCredentials = true;
import { SERVICE_CATEGORY_SUCCESS_CODE,SOMETHING_WENT_WRONG } from '../../constants';
import COMMON_API from '@commonapi';
import { EXPIRED_TOKEN } from '@constants';

/* getLogedinUserDetails */
export const getLoggedInUser = () => {
    const UserInfo = localStorage.getItem('userDetails');
    if (UserInfo) return JSON.parse(UserInfo);
    return null;
};

/* getRefreshToken */
let refreshTokenPromise = null;

export const getRefreshToken = async () => {
    if (!refreshTokenPromise) {
        const user = getLoggedInUser();
        const params = { token: user?.refresh_token };
        refreshTokenPromise = (async () => {

            let refresh_token = '';
            const response1 = await axios.post(import.meta.env.VITE_API_URL + COMMON_API.REFRESHTOKEN, params);
            if (response1?.data?.tokenResult) {
                // alert("Refresh Token - Success");
                if (response1?.data?.tokenResult?.status === EXPIRED_TOKEN) {
                    await errorLog({ message: 'auth-service' }, 'auth-service', 'getRefreshToken');
                    localStorage.removeItem('userDetails');
                    const userId = {
                        'user_id': 0,
                        'user_name': '0',
                    };
                    const data = Object.assign({}, userId);
                    localStorage.setItem('userDetails', JSON.stringify(data));
                    localStorage.setItem('isAuthenticated', false);
                    return response1?.data?.tokenResult?.status;
                }

                const access_token = response1?.data?.tokenResult?.access_token;
                refresh_token = response1?.data?.tokenResult?.refresh_token;
                const data = Object.assign({}, user);
                data.access_token = access_token ? access_token : data.access_token;
                data.refresh_token = refresh_token ? refresh_token : data.refresh_token;
                localStorage.setItem('userDetails', JSON.stringify(data));
                // return access_token
            } else {
                // alert("Refresh Token - Error");
                // return ''
            }
            return refresh_token;
        })();

        refreshTokenPromise.finally(() => {
            refreshTokenPromise = null;
        });
    }

    return refreshTokenPromise;
};

/* userLogout */
export const userLogout = async (navigate) => {
    localStorage.removeItem('userDetails');
    const userId = {
        'user_id': 0,
        'user_name': 'expired',
    };
    const data = Object.assign({}, userId);
    localStorage.setItem('userDetails', JSON.stringify(data));
    localStorage.setItem('isAuthenticated', false);
    navigate('/session/signin');
};

/* errorLog */
export const errorLog = async (error, module, functionality) => {
    const user = getLoggedInUser();
    /* Error Log */
    const data = {
        'user_id': Number(user?.user_id),
        'user_name': user?.user_name,
        'platform': 'Portal',
        'Module': module,
        'error': error?.message,
        'functionality': functionality,
    };

    const response = await axios.post(import.meta.env.VITE_API_URL + COMMON_API?.ERROR_LOG_INFO, data, {
        headers: {
            'Authorization': `Bearer ${user?.access_token}`,
            'X-CSRF-Token': user?.csrf_Token,
        },
    });
    return response;
};

/* NetWork  Checking*/
export const checkApiUrl = async () => {
    try {
        const response = await axios.get(import.meta.env.VITE_API_URL);

        if (response.data === 'Dhall Mill API') {
            return true;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const getStateList = async (data) => {
    try {
        const response = await callApi({
            endpoint: COMMON_API?.GET_MASTER_DATA,
            method: 'post',
            data,
            module: 'State List',
            functionality: 'State List',
        });

        const successCode = response?.successcode;
        const message = response?.message || '';

        if (successCode === SERVICE_CATEGORY_SUCCESS_CODE) {
            return {
                success: true,
                message: '',
                data: response?.data?.stateList || [],
            };
        } else {
            return {
                success: false,
                message: message,
                data: [],
            };
        }
    } catch (error) {
        errorLog(error, 'State List', 'getStateList');
        return {
            success: false,
            message: SOMETHING_WENT_WRONG,
            data: [],
        };
    }
};

export const getStatusList = async (data) => {
    try {
        const response = await callApi({
            endpoint: COMMON_API?.GET_MASTER_DATA,
            method: 'post',
            data,
            module: 'Status List',
            functionality: 'Status List',
        });

        const successCode = response?.successcode;
        const message = response?.message || '';

        if (successCode === SERVICE_CATEGORY_SUCCESS_CODE) {
            return {
                success: true,
                message: '',
                data: response?.data?.statusList || [],
            };
        } else {
            return {
                success: false,
                message: message,
                data: [],
            };
        }
    } catch (error) {
        errorLog(error, 'Status List', 'getStatusList');
        return {
            success: false,
            message: SOMETHING_WENT_WRONG,
            data: [],
        };
    }
};

export const getPartyList = async (data) => {
    try {
        const response = await callApi({
            endpoint: COMMON_API?.GET_MASTER_DATA,
            method: 'post',
            data,
            module: 'Party List',
            functionality: 'Party List',
        });

        const successCode = response?.successcode;
        const message = response?.message || '';

        if (successCode === SERVICE_CATEGORY_SUCCESS_CODE) {
            return {
                success: true,
                message: '',
                data: response?.data?.partiesList || [],
            };
        } else {
            return {
                success: false,
                message: message,
                data: [],
            };
        }
    } catch (error) {
        errorLog(error, 'Party List', 'getPartyList');
        return {
            success: false,
            message: SOMETHING_WENT_WRONG,
            data: [],
        };
    }
};

export const getSalesRepList = async (data) => {
    try {
        const response = await callApi({
            endpoint: COMMON_API?.GET_MASTER_DATA,
            method: 'post',
            data,
            module: 'Sales Rep List',
            functionality: 'Sales List',
        });

        const successCode = response?.successcode;
        const message = response?.message || '';

        if (successCode === SERVICE_CATEGORY_SUCCESS_CODE) {
            return {
                success: true,
                message: '',
                data: response?.data?.salesrepsList || [],
            };
        } else {
            return {
                success: false,
                message: message,
                data: [],
            };
        }
    } catch (error) {
        errorLog(error, 'Sales Rep List', 'getSalesRepList');
        return {
            success: false,
            message: SOMETHING_WENT_WRONG,
            data: [],
        };
    }
};

export const getMasterData = async (data) => {
    try {
        const response = await callApi({
            endpoint: COMMON_API?.GET_MASTER_DATA,
            method: 'post',
            data,
            module: 'Master Data',
            functionality: 'Master Data',
        });

        const successCode = response?.successcode;
        const message = response?.message || '';

        if (successCode === SERVICE_CATEGORY_SUCCESS_CODE) {
            return {
                success: true,
                message: '',
                data: {
                    statusList: response?.data?.statusList || [],
                    partiesList: response?.data?.partiesList || [],
                    salesrepsList: response?.data?.salesrepsList || [],
                },
            };
        } else {
            return {
                success: false,
                message: message,
                data: { statusList: [], partiesList: [], salesrepsList: [] },
            };
        }
    } catch (error) {
        errorLog(error, 'Master Data', 'getMasterData');
        return {
            success: false,
            message: SOMETHING_WENT_WRONG,
            data: { statusList: [], partiesList: [], salesrepsList: [] },
        };
    }
};